import axios from 'axios'
import config from '@/config'

const pfServices = {
  async createDoc(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/create',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async getDocs() {
    try {
      let res = await axios({ method: 'GET', url: config.BASE_API_LOGIN_URL + '/pf/list' })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async updateDoc(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/update',
        data: data,
      })
      return res.data
    } catch (e) {
      // console.log('e: ', e.response)
      throw e
    }
  },
  async reorderDoc(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/reorder',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async uploadFile(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_URL + '/profile/candidate/pf/upload',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async getNewStatusCandidate(data) {
    try {
      let res = await axios({
        method: 'GET',
        url:
          config.BASE_API_LOGIN_URL +
          `/pf/candidate/list?count=${data.count}&page=${data.page}${
            data.textSearch ? '&candidateEmail=' + data.textSearch : ''
          }`,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async markSeen(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/seen',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async sendFiles(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/email/attachment',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async updateStatus(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/pf/status/update',
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },
  async deleteDoc(data) {
    try {
      await axios({
        method: 'POST',
        url: config.BASE_API_URL + '/profile/candidate/pf/delete',
        data: data,
      })
    } catch (e) {
      throw e.response
    }
  },
}

export default pfServices
